import { UploadNewMediaOptions } from '@/types/media';
import { getRequest, postRequest } from './amplify/helpers';
import { getAssetsUrl } from '@/utils/public-urls';
import { useUserDataStore } from '@/stores/userDataStore';

export enum S3UploadAssetType {
  Video = 'video',
  Image = 'imageAsset',
  Output = 'output',
}

const getSignedUrl = (type, path) => {
  return getRequest({
    apiName: 'uploadUrl',
    path: '/actions/upload/app/get-signed-url',
    options: {
      queryParams: {
        type,
        path,
      },
    },
  });
};

export const upload = (url, file, progressCallback) => {
  console.log({ url, file, progressCallback });
  return new Promise(function (resolve, reject) {
    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) {
        return;
      }
      if (xhr.status === 200) {
        resolve(xhr);
      } else {
        reject(xhr.statusText);
      }
    };

    if (progressCallback) {
      xhr.upload.onprogress = (event) => {
        if (!event.lengthComputable) {
          return;
        }
        const percentComplete = (event.loaded / file.size) * 100;
        progressCallback(percentComplete);
      };
    }

    xhr.open('PUT', url);
    try {
      xhr.send(file);
    } catch (error) {
      reject(xhr.statusText + error);
    }
    xhr.addEventListener('error', (error) => {
      reject(xhr.statusText + error);
    });
  });
};

const invalidateByUrl = async (url) => {
  try {
    const response = await postRequest({
      apiName: 'publishActions',
      path: '/actions/projects/invalidateByUrl',
      options: {
        body: {
          appKey: useUserDataStore.getState().appKey,
          url,
        },
      },
    });
    if (response.err) {
      console.log('failed to invalidate url', response.err);
    }
    return response;
  } catch (error) {
    return null;
  }
};

export const uploadToS3 = async ({ type, path, file, progressCallback = undefined, shouldInvalidate = false }) => {
  const { uploadURL } = await getSignedUrl(type, path);

  await upload(uploadURL, file, progressCallback);

  if (shouldInvalidate) {
    await invalidateByUrl(getAssetsUrl() + path);
  }
};

export const uploadNewMedia = async (file: File, options: UploadNewMediaOptions) => {
  const { id, baseFolder, fileExtension } = options;
  const path = `public/${baseFolder}/${id}/${id}.${fileExtension || 'webp'}`;
  console.log({ path });

  await uploadToS3({ type: S3UploadAssetType.Output, path, file });
  return path;
};

export const sanitizeFileName = (fileName: string): string => {
  const lastDotIndex = fileName.lastIndexOf('.');
  // If there's no extension, just sanitize the whole string
  if (lastDotIndex === -1) {
    return fileName.replace(/[^a-zA-Z0-9-_]+/g, '_');
  }

  const namePart = fileName.substring(0, lastDotIndex).replace(/[^a-zA-Z0-9-_]+/g, '_');
  const extPart = fileName.substring(lastDotIndex); // includes the dot
  return namePart + extPart;
};
